module.exports = __webpack_public_path__ + "img/0Q3A9771_L_Wood_MockedUp.accfac1b.jpg";